import script from "./EurostarTimeLine.vue?vue&type=script&setup=true&lang=ts"
export * from "./EurostarTimeLine.vue?vue&type=script&setup=true&lang=ts"

import "./EurostarTimeLine.vue?vue&type=style&index=0&id=061925a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-061925a8"]])

export default __exports__